module.exports = __webpack_public_path__ + "img/myMember-select.63300100.svg";